import { WebClient } from "./server/WebClient";

export const WordFileService = {
    isDocxFile: (file: File) => {
        // Although this is the official type, it's not uncommon for it not to be set
        if (file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            return true;
        }
        let fileNameSplit = file.name.split('.');
        let extension = fileNameSplit[fileNameSplit.length - 1].toLowerCase();
        return extension === "docx";
    },
    parseDocxFile: (file: File) => WebClient.Post.File.Internal<{ html: string }>("api/WordFileConversion", file)
}